export const priceFormatter = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "CHF",
    minimumFractionDigits: 2,
});
export const formatPrice = (input) => priceFormatter.format(input / 100);
//# sourceMappingURL=index.js.map